

const setupArticle = () => {

    const article = document.getElementById('article')
    const articleHotLinks = document.getElementById('articleHotLinks')
    if(article && articleHotLinks) {
        createMenu(article, articleHotLinks)
    }

}


const createMenu = (article, articleHotLinks) => {

    const section = document.createElement('section');
    section.setAttribute("class", 'article-hot-links');

    const container = document.createElement('div');
    container.setAttribute("class", 'container');
    section.appendChild(container)

    const title = document.createElement('span');
    title.setAttribute("class", 'article-hot-links__title');
    title.innerText = "In this article";
    container.appendChild(title)

    const ul = document.createElement('ul');
    container.appendChild(ul)

    const articleH2s = article.querySelectorAll('h2')

    if(!articleH2s.length) return

    articleH2s.forEach((h2, i) => {

        const target = 'targetHeading' + i
        const linkClass = i > 2 ? 'hide-row' : ''
        const wrapper = document.createElement('span');
        wrapper.setAttribute("id", target);

        // insert wrapper before el in the DOM tree
        h2.parentNode.insertBefore(wrapper, h2);
        // move el into wrapper
        wrapper.appendChild(h2);

        // Add link to ul
        const li  = document.createElement('li');
        const a  = document.createElement('a');
        a.innerHTML = h2.innerText

        a.addEventListener('click', () => {
            h2.scrollIntoView({ behavior: "smooth", block: "start" });
        })

        li.appendChild(a)
        ul.appendChild(li)

    })

    articleHotLinks.appendChild(section)

    // if($('article h2').length > 3){
    //     $('#article_links').append("<div class='article-links__more'>See more</div>")
    // }

}


window.addEventListener('load', setupArticle);
